export default "__VITE_ASSET__Dcu0Mjsk__"